var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"APinItemIcon",on:{"click":_vm.emit}},[_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.loading},on:{"update:active":function($event){_vm.loading=$event}}}),_c('a-pin-svg-icon',{attrs:{"pinned":_vm.pin}}),_c('span',[_vm._v(_vm._s(_vm.pinCount ? 'x' + _vm.pinCount : ''))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }